import React from 'react';
import './Homepage.css';

const Certifications = () => {
  return (
    <div className='container-fluid' id='certifications-section'>
      <div className="row heading-row">
           CERTIFICATIONS
      </div>
      <div className="row certifications-row">
        <div className="col-6 col-xl-2 col-lg-3 col-sm-4 "><img src='img-data/homepage/certifications/certification-1.jpg'/></div>
        <div className="col-6 col-xl-2 col-lg-3 col-sm-4 "><img src='img-data/homepage/certifications/certification-2.jpg'/></div>
        <div className="col-6 col-xl-2 col-lg-3 col-sm-4 "><img src='img-data/homepage/certifications/certification-3.jpg'/></div>
        <div className="col-6 col-xl-2 col-lg-3 col-sm-4 "><img src='img-data/homepage/certifications/certification-4.jpg'/></div>
        <div className="col-6 col-xl-2 col-lg-3 col-sm-4 "><img src='img-data/homepage/certifications/certification-5.jpg'/></div>
        <div className="col-6 col-xl-2 col-lg-3 col-sm-4 "><img src='img-data/homepage/certifications/certification-6.jpg'/></div>
        <div className="col-6 col-xl-2 col-lg-3 col-sm-4 "><img src='img-data/homepage/certifications/certification-7.jpg'/></div>
        <div className="col-6 col-xl-2 col-lg-3 col-sm-4 "><img src='img-data/homepage/certifications/certification-8.jpg'/></div>
        <div className="col-6 col-xl-2 col-lg-3 col-sm-4 "><img src='img-data/homepage/certifications/certification-9.jpg'/></div>
        <div className="col-6 col-xl-2 col-lg-3 col-sm-4 "><img src='img-data/homepage/certifications/certification-10.jpg'/></div>
        <div className="col-6 col-xl-2 col-lg-3 col-sm-4 "><img src='img-data/homepage/certifications/certification-11.jpg'/></div>
        <div className="col-6 col-xl-2 col-lg-3 col-sm-4 "><img src='img-data/homepage/certifications/certification-13.png'/></div>
        <div className="col-6 col-xl-2 col-lg-3 col-sm-4 "><img src='img-data/homepage/certifications/certification-12.jpg'/></div>
      </div>
      
    </div>
  )
}

export default Certifications
